// extracted by mini-css-extract-plugin
export default {"mobile-footer":"mobileFooter_mobile-footer__zUYzj"};